"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const InputWidget_1 = tslib_1.__importDefault(require("../widget/InputWidget"));
const Span_1 = tslib_1.__importDefault(require("../elements/Span"));
const Tag_1 = tslib_1.__importDefault(require("../elements/Tag"));
/**
 * @deprecated use {@link WCAGRadioButton}
 */
class RadioButton extends InputWidget_1.default {
    constructor({ value, input, inputLabel, labelString, enabled = true, selected = false }) {
        super(input || document.createElement("input"));
        this.enabled = enabled;
        if (labelString) {
            this.labelString = labelString;
        }
        if (input && !inputLabel) {
            throw new Error("An input label is required when using input as a wrapping argument");
        }
        if (selected) {
            this._input.checked = true;
        }
        if (!this.enabled) {
            this.setEnabled(false);
        }
        this.setValue(value, false);
    }
    wrapButton(id) {
        const span = new Span_1.default();
        span.getCssStyle().display = "block";
        span.getCssStyle().paddingBottom = "8px";
        const label = new Tag_1.default("label", this.labelString);
        label.element.setAttribute("for", id);
        if (!this.enabled) {
            label.getCssStyle().opacity = "0.5";
        }
        this._input.id = id;
        span.add(this._input);
        span.add(label);
        return span;
    }
    setValue(value, fireEvents = false) {
        super.setValue(value, fireEvents);
        this.fireEvent(new fmko_ts_common_1.ValueChangeEvent(value));
    }
    decorateElement(element) {
        element.type = "radio";
        element.style.margin = "0 8px 0 0";
    }
    setValueOnInput(value, input) {
        return value;
    }
    parseValueFromInput(inputValue) {
        return this.value;
    }
}
exports.default = RadioButton;
//# sourceMappingURL=RadioButton.js.map